import React from 'react';
import { Container } from '../components/Container';
import { Shield, Factory, Users, TrendingDown } from 'lucide-react';
import { Link } from 'react-router-dom';
export function About() {
  return <div className="w-full bg-white" data-id="element-326">
      {/* Hero */}
      <div className="bg-[#111827] text-white py-20 relative overflow-hidden" data-id="element-327">
        <div className="absolute inset-0 z-0" data-id="element-328">
          <img src="https://images.unsplash.com/photo-1574629810360-7efbb1925536?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Team Huddle" className="w-full h-full object-cover opacity-30" data-id="element-329" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#111827] via-[#111827]/90 to-transparent" data-id="element-330"></div>
        </div>

        <Container className="relative z-10" data-id="element-331">
          <div className="max-w-3xl" data-id="element-332">
            <h1 className="font-oswald text-4xl md:text-5xl lg:text-6xl font-bold uppercase mb-4" data-id="element-333">
              About Primetime Sports
            </h1>
            <div className="w-20 h-1.5 bg-pts-red mb-6" data-id="element-334"></div>
            <p className="text-xl text-gray-300 leading-relaxed" data-id="element-335">
              We believe that ordering custom team uniforms shouldn't be
              stressful, expensive, or complicated. We built PTS to give teams
              factory-direct access to premium gear.
            </p>
          </div>
        </Container>
      </div>

      {/* Main Narrative */}
      <section className="py-20" data-id="element-336">
        <Container data-id="element-337">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-338">
            <div className="lg:w-1/2" data-id="element-339">
              <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase text-gray-900 mb-6" data-id="element-340">
                Factory-Direct Control. <br data-id="element-341" />
                <span className="text-pts-red" data-id="element-342">Unbeatable Value.</span>
              </h2>
              <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-343">
                <p data-id="element-344">
                  Primetime Sports Apparel (PTS) was founded on a simple
                  premise: cut out the middlemen. By operating factory-direct,
                  we maintain full control over the production process from the
                  initial design to the final stitch.
                </p>
                <p data-id="element-345">
                  This control allows us to offer high-quality, fully sublimated
                  custom gear at prices that traditional retail brands simply
                  cannot match. Send us a comparable quote and we'll help you
                  compare with no-nonsense factory-direct pricing, USA-based
                  support, and organized production.
                </p>
                <p data-id="element-346">
                  But great pricing means nothing without reliability. That's
                  why we've built an ordering process focused on accuracy,
                  featuring free initial art mockups, mini photo approvals, and
                  full-size sample checks before your team's order ever hits the
                  production floor.
                </p>
              </div>
            </div>
            <div className="lg:w-1/2 w-full" data-id="element-347">
              <div className="relative" data-id="element-348">
                <div className="absolute -inset-3 bg-pts-red/10 rounded-2xl transform rotate-2" data-id="element-349"></div>
                <img src="https://cdn.magicpatterns.com/uploads/shtxuYWATmr87BaFU8L23Q/About_Us.png" alt="Custom team celebrating in PTS uniforms on the field" className="relative rounded-xl shadow-xl w-full h-auto object-cover border border-gray-200" data-id="element-350" />
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-gray-50 border-y border-gray-200" data-id="element-351">
        <Container data-id="element-352">
          <div className="text-center mb-16" data-id="element-353">
            <h2 className="font-oswald text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-354">
              What Drives Us
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mx-auto" data-id="element-355"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-356">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center" data-id="element-357">
              <Factory className="h-12 w-12 text-pts-red mx-auto mb-6" data-id="element-358" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-359">
                Factory Direct
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-360">
                No middlemen. We control the facility, the timeline, and the
                quality of every garment we produce.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center" data-id="element-361">
              <TrendingDown className="h-12 w-12 text-pts-red mx-auto mb-6" data-id="element-362" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-363">
                Unbeatable Value
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-364">
                We are committed to making team sports affordable. Have a quote?
                Send it to us and we'll help you compare.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center" data-id="element-365">
              <Shield className="h-12 w-12 text-pts-red mx-auto mb-6" data-id="element-366" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-367">
                Confidence
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-368">
                Through our rigorous approval process and sample programs, you
                know exactly what you're getting.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center" data-id="element-369">
              <Users className="h-12 w-12 text-pts-red mx-auto mb-6" data-id="element-370" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-371">
                Relationships
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-372">
                We don't just want your first order; we want to outfit your
                program for years to come.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* CTA */}
      <section className="py-20 bg-pts-red text-white text-center" data-id="element-373">
        <Container data-id="element-374">
          <h2 className="font-oswald text-4xl font-bold uppercase mb-6" data-id="element-375">
            Experience the PTS Difference
          </h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto mb-10" data-id="element-376">
            Join the thousands of teams, schools, and leagues that trust
            Primetime Sports Apparel for their custom gear.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-377">
            <Link to="/get-started" className="bg-white text-pts-red hover:bg-gray-100 px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors shadow-lg" data-id="element-378">
              Start Your Order
            </Link>
            <Link to="/contact" className="bg-transparent border-2 border-white hover:bg-white hover:text-pts-red text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors" data-id="element-379">
              Contact Our Team
            </Link>
          </div>
        </Container>
      </section>
    </div>;
}